import { render, staticRenderFns } from "./ActionBox.vue?vue&type=template&id=0d31986c&scoped=true&"
import script from "./ActionBox.vue?vue&type=script&lang=js&"
export * from "./ActionBox.vue?vue&type=script&lang=js&"
import style0 from "./ActionBox.vue?vue&type=style&index=0&id=0d31986c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d31986c",
  null
  
)

export default component.exports